/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, Backbone, mp */

_.namespace(`mp.marketing.trends`, function(ns) {
  'use strict';

  // optional chaining to prevent JS errors due to JS/ad blockers
  // eslint-disable-next-line camelcase,no-unused-expressions,babel/no-unused-expressions
  mp?.report?.init_tracking?.(`e66247df293c78f4bea18a2f4bf9fd70`, {persistence: `localStorage`}, `marketing_trends`); // 212780
  // eslint-disable-next-line camelcase,no-unused-expressions,babel/no-unused-expressions
  mp?.report?.init_tracking?.(`8841239489aa93a116badc7584600de2`, {persistence: `localStorage`}, `blog`); // 347031

  ns.session = new Backbone.Model({
    page: ``,
    report: ``,
  });

  var report_by_slug = {};
  _.each(ns.reports, function(report) {
    report_by_slug[report.slug] = report;
  });

  ns.bootstrap = function() {
    var Router = Backbone.ViewRouter.extend({
      session: ns.session,
      render_target: $(`#render_target`),

      routes: {
        "":                     `lead_in`,
        "report/:report":       `report`,
        "report/:report/":      `report`,
        "report/:report:rison": `report`,
      },

      lead_in() {
        return {
          view: ns.LeadinViewer,
        };
      },

      report(report_slug, rison) {
        if (report_slug === `android_kitkat` || report_slug === `android_lollipop`) {
          this.navigate(`report/android_os_adoption`, {trigger: true, replace: true});
          return;
        }
        if (!report_by_slug[report_slug]) {
          this.navigate(``, {trigger: true, replace: true});
          return;
        }
        return {
          rison,
          view: report_by_slug[report_slug].view_class || ns.ReportViewer,
          session: {report: report_slug},
        };
      },

      // Navigation Helpers
      goto_report(report_slug, skip_route_trigger) {
        this.navigate(`report/` + report_slug, !skip_route_trigger);
        this.session.set(`report`, report_slug);
      },
    });

    // initialize the router
    ns.router = new Router();

    if (!Backbone.history.start()) {
      // invalid route
      ns.router.navigate(``, true);
    }
  };
});

}.call(window));